import React, { useEffect } from 'react'
import About from '../../components/about/About'
import Loader from '../../components/preloader/Loader';
import Nav from '../../components/nav/Nav';
import BotDiv from '../../components/botdiv/BotDiv';

function AboutPage({ loaderFinished, setLoaderFinished }) {
  useEffect(()=>{
    setLoaderFinished(false);
  },[setLoaderFinished]);
  
  return (
    <div>
        <Loader loaderFinished={setLoaderFinished} data="about" show2={false} />
        {loaderFinished && (
          <>
            <Nav inHome={false}/>
            <About/>
            <BotDiv/>       
          </>
        )}
    </div>
  )
}

export default AboutPage